export const handlerApiRequests = async (
    response, {
    dispatch, getState, rejectWithValue }, toasts) => {
        
}